import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    getPaymentMethods: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/payments/get_payment_methods";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    createCheckoutSession: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/payments/create_checkout_session";

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    retrieveCheckoutSession: async ({ missionId, session_id, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/payments/retrieve_checkout_session?session_id=" + session_id;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    createCryptoPayment: async ({ missionId, walletAddress, blockchain, companyCountry, companyAddress, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/payments/create_crypto_payment";

        const body = JSON.stringify({
            crypto_payment: {
                wallet_address: walletAddress,
                blockchain: blockchain,
                company_country: companyCountry,
                company_address: companyAddress
            }
        })

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },



    createInvoicePayment: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/payments/create_invoice_payment";

        const body = JSON.stringify({
            invoice_payment: {

            }
        })
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }
}